import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, Signal, signal } from '@angular/core';
import { FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Modal } from '@spirit-testing/component-library';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { TestConnectionResult } from '../../../models/project-integration.model';

@Component({
  selector: 'app-provider-board-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    Modal,
    MatButton,
    MatIconButton,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    MatIcon,
    MatProgressSpinner,
    MatTooltip,
  ],
  templateUrl: './provider-board-section.component.html',
  styleUrl: './provider-board-section.component.scss',
})
export class ProviderBoardSectionComponent {
  @Input({ required: true }) boardUrls!: FormArray<FormControl<string>>;
  @Input({ required: true }) integrationIds!: Signal<(string | null)[]>;
  @Input({ required: true }) testResults!: Signal<(TestConnectionResult | null)[]>;
  @Input({ required: true }) isTesting!: Signal<boolean[]>;
  @Input({ required: true }) maxBoards!: number;

  @Output() addBoard = new EventEmitter<void>();
  @Output() removeBoard = new EventEmitter<number>();
  @Output() testBoard = new EventEmitter<number>();

  readonly pendingRemoveIndex = signal<number | null>(null);

  onRemoveClick(index: number): void {
    this.pendingRemoveIndex.set(index);
  }

  onRemoveConfirmed(): void {
    const index = this.pendingRemoveIndex();
    this.pendingRemoveIndex.set(null);
    if (index !== null) {
      this.removeBoard.emit(index);
    }
  }

  onRemoveCancelled(): void {
    this.pendingRemoveIndex.set(null);
  }
}
